/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_Dry_Run_MissingInputs */

const en_error_crm_send_dry_run_missing = /** @type {(inputs: Error_Crm_Send_Dry_Run_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run the dry run again: yours is missing, older than an hour, or the send changed.`)
};

/**
* | output |
* | --- |
* | "Run the dry run again: yours is missing, older than an hour, or the send changed." |
*
* @param {Error_Crm_Send_Dry_Run_MissingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_dry_run_missing = /** @type {((inputs?: Error_Crm_Send_Dry_Run_MissingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_Dry_Run_MissingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_dry_run_missing(inputs)
});